const WertheimAdministrator = 1;
const WertheimSales = 2;
const SalesPartnershipAdmin = 3;
const SalesPartnershipSales = 4;
const SalesPartnershipProductConfigurator = 5;
const AffiliatePartnershipSales = 6;


export default {
    WertheimAdministrator: WertheimAdministrator,
    WertheimSales: WertheimSales,
    SalesPartnershipAdmin: SalesPartnershipAdmin,
    SalesPartnershipSales: SalesPartnershipSales,
    SalesPartnershipProductConfigurator : SalesPartnershipProductConfigurator,
    AffiliatePartnershipSales : AffiliatePartnershipSales
  }

  export const getUserTypeLabel = (userType: Number) => {
      switch (userType) {
          case WertheimAdministrator:
              return 'wertheimAdministratorLabel'
          case WertheimSales:
              return 'wertheimSalesLabel'
          case SalesPartnershipAdmin:
              return 'spaLabel'
          case SalesPartnershipSales:
              return 'spsLabel'
          case SalesPartnershipProductConfigurator:
              return 'sppcLabel'
          case AffiliatePartnershipSales:
              return 'apsLabel'
      }
  }
